import React, { Suspense, lazy } from 'react';
import './App.css';
import AppProviders from './providers/AppProviders';
import AppRoutes from './routes/AppRoutes';

// Deep-lazy-load UqdaSplash (NOT via the mascot barrel) so framer-motion
// stays out of main.js. The barrel re-exports UqdaAnimated/UqdaBannerLoader,
// which import motion/react — importing it eagerly would pin framer to the
// main chunk. UqdaSplash returns null under SSR and gates on sessionStorage,
// so a null Suspense fallback preserves react-snap prerender output.
const UqdaSplash = lazy(() => import('../components/mascot/UqdaSplash'));

// AppBootstrapper moved into StoreShell (which AppRoutes mounts lazily around
// routes that need Redux). The public landing tree skips it entirely.
const App = () => (
  <AppProviders>
    <Suspense fallback={null}>
      <UqdaSplash />
    </Suspense>
    <AppRoutes />
  </AppProviders>
);

export default App;
